import { Component } from '@angular/core';

import { GlobalListComponent } from '../../shared/global-list';

@Component({
  selector: 'app-unauthorized',
  imports: [],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss',
})
export class UnauthorizedComponent extends GlobalListComponent {
  goHome() {
    this.router.navigate(['/main/dashboard']);
  }
}
